<template>
  <SubLayout
      :pageTitle="title"
      :pageBreadcrumbs="breadcrumbs"
      :hasBack="true"
  >
    <template #subHeaderActions>
      <div class="d-flex align-items-center gap-2 gap-lg-3">

      </div>
    </template>

    <template #layoutContent>
      <div class="card shadow-sm">
        <div class="card-header min-h-50px">
          <h2 class="card-title fs-1">{{ $t('qvct_survey.survey.list') }}</h2>
          <div class="card-toolbar">
            <router-link :to="{name: 'qvct-survey-create'}" class="btn py-2 btn-primary">
              <i class="fas fa-plus"></i>
              {{ $t('qvct_survey.create_survey') }}
            </router-link>
          </div>
        </div>
        <div class="card-body card-scroll survey_card_height">
          <div class="row">
            <div v-if="qvctSurveys.length" class="col-12 col-md-4 col-sm-6 col-lg-3 mb-10 cursor-pointer" v-for="survey in qvctSurveys" :key="survey.id">
              <survey-card :survey="survey"/>
            </div>

            <div  v-else class="row text-center justify-content-center align-items-center" style="height :5vh !important;width: 100%!important;">
              <div class=" text-center ">
                <div class="pt-8 ">
                  <Img filename="empty.png" alt=""
                       class="mw-100 h-150px h-sm-150px" />
                </div>
                <h2 class="fs-2x fw-bolder mb-0">{{ $t('qvct_survey.no_survey_found') }}</h2>
                <p class="text-gray-400 fs-4 fw-bold py-7">{{ $t('button.clic') }}<br /></p>
                <router-link :to="{name: 'qvct-survey-create'}" class="btn py-2 btn-primary">
                  <i class="fas fa-plus"></i>
                  {{ $t('qvct_survey.create_survey') }}
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </SubLayout>
</template>

<script setup>
import SubLayout from "@/views/Layouts/partials/SubLayout.vue";
import {onMounted, ref, computed} from "vue";
import SurveyCard from "@/Modules/Qvct/views/Survey/components/SurveyCard.vue";
import {useStore} from "vuex";
import Img from "@/components/Img.vue";
import Button from "@/components/Button.vue";

const store = useStore()

const title = ref('qvct_survey.survey.list')

const qvctSurveys = computed(() => store.getters['qvctSurvey/getQvctSurveys'])

const breadcrumbs = ref([
  {
    name: 'navigation.dashboard',
    route: 'home-path'
  },
  {
    name: 'navigation.qvct_survey',
    route: 'qvct-survey-index'
  }
])

onMounted(() => {
  store.dispatch('qvctSurvey/loadSurveys')
})

</script>

<style scoped>
  .survey_card_height {
    height: calc(100vh - 280px);
  }
</style>